import React, { Component } from 'react'
import Link from '../../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class ArticleCard extends Component {

  render() {

    const { featuredImage, categories, title, slug, filter } = this.props

    return (

      <div className='article'>
  
        <div className='article__image'>
                      
          <img loading='lazy' src={featuredImage?.node?.sourceUrl} alt={title} />
          <span className='article__tag'>{ filter || categories.nodes[0].name }</span>

          <div className='article__title'>
            <h4 dangerouslySetInnerHTML={{ __html: title }} />
          </div>

        </div>

        <Link className='article__link' to={`/media-centre/${slug}/`} />
      
      </div>
    )
  }
}

export default ArticleCard
